import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEOHead({ title, description, keywords, image, url, type = 'website' }) {
    const siteTitle = 'Amorlias';
    const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const defaultDescription = 'Wholesale ecommerce store for Home & Kitchen products.';
    const metaDescription = description || defaultDescription;
    const defaultKeywords = 'wholesale, ecommerce, home, kitchen, bulk, amorlias, b2b, wholesale market, kitchenware, home decor, bulk buying, reseller, business supplies, indian wholesale, dropshipping, retailers, household items, affordable wholesale, kitchen appliances, crockery, gift items,amorlais mart,amorlais,amorlais mart wholesale,amorlais mart b2b,amorlais mart kitchenware,amorlais mart home decor,amorlais mart bulk buying,amorlais mart reseller,amorlais mart business supplies,amorlais mart indian wholesale,amorlais mart dropshipping,amorlais mart retailers,amorlais mart household items,amorlais mart affordable wholesale,amorlais mart kitchen appliances,amorlais mart crockery,amorlais mart gift items,amorlais mart wholesale,amorlais mart b2b,amorlais mart kitchenware,amorlais mart home decor,amorlais mart bulk buying,amorlais mart reseller,amorlais mart business supplies,amorlais mart indian wholesale,amorlais mart dropshipping,amorlais mart retailers,amorlais mart household items,amorlais mart affordable wholesale,amorlais mart kitchen appliances,amorlais mart crockery,amorlais mart gift items,raj computers,orchild mall,kids bags, water bottles,wholesale, ecommerce, home, kitchen, bulk, amorlias, amorlias mart, b2b, wholesale market, kitchenware, home decor, bulk buying, reseller, business supplies, indian wholesale, dropshipping, retailers, household items, affordable wholesale, kitchen appliances, crockery, gift items, kids bags, water bottles, lunch boxes, school supplies, return gifts, corporate gifts, stationery, storage containers, cookware, utensils, cleaning supplies, organizers, raj computers, orchid mall, best wholesale price';
    const metaKeywords = keywords || defaultKeywords;
    const siteUrl = window.location.origin;
    const currentUrl = url || window.location.href;
    const defaultImage = `${siteUrl}/icons/icon-512.png`; // Fallback image
    const metaImage = image || defaultImage;

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={metaImage} />
            <meta property="og:site_name" content={siteTitle} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={currentUrl} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={metaDescription} />
            <meta property="twitter:image" content={metaImage} />

            {/* Canonical URL */}
            <link rel="canonical" href={currentUrl} />
        </Helmet>
    );
}
